import React, { ReactNode } from "react";
import { SelectProps, Select } from "@mui/material";
import { WcSelect } from "@bpipartners/webui";

type CustomSelectComponentProps = SelectProps & {
  controldisabled?: boolean;
  useFullWidth?: boolean;
  children: ReactNode;
  size?: string;
};

export const CustomSelectComponent = ({
  size = "small",
  useFullWidth = true,
  controldisabled,
  children,
  ...others
}: CustomSelectComponentProps) => (
  <WcSelect
    id="CustomSelect"
    disabled={controldisabled}
    fullWidth={useFullWidth ? true : false}
    size={size}
    {...others}
  >
    {children}
  </WcSelect>
);

export default CustomSelectComponent;
